export default __webpack_public_path__ + "static/media/icw-userzoom.900fd252.jpg";